/**
 * #######################################################@
 *
 * Pages settings
 *
 * #######################################################@
 */
import { useEffect } from "react";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";

export default function Step4Confirm({ validStep, choice }) {
	useEffect(() => {
		validStep();
	}, []);

	function getChoice(choice) {
		switch (choice) {
			case "add":
				return "Les données seront ajoutées aux données éxistantes.";
			case "remove":
				return "Attention, cette action va remplacer toutes les données en base de données.\n\nVoulez vous confirmer ?";
			default:
				return "Les données seront ajoutées aux données éxistantes.";
		}
	}

	return (
		<MDBox
			sx={{ ml: 30, mr: 30 }}
			style={{
				height: "100%"
			}}
		>
			<MDBox
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				style={{
					height: "100%",
					whiteSpace: "break-spaces"
				}}
			>
				<MDTypography color={choice === "remove" ? "error" : ""} variant="h3">
					{getChoice(choice)}
				</MDTypography>
			</MDBox>
		</MDBox>
	);
}
